import moment from 'moment';
import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalFooter } from 'reactstrap';
import { actions } from '../../context';
import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';

// TODO: we are not using this feature, don't render this feature for now?
const UpdatesModal = () => {

    const dispatch = useDispatch();

    const isUpdateNotesModalOpen = useSelector((state) => state.toggle.isUpdateNotesModalOpen);

    const updates = useSelector((state) => state.meta.updates, shallowEqual);

    useEffect(() => {
        if (isUpdateNotesModalOpen)
            dispatch(actions.meta.fetchUpdates()).then(() =>
                dispatch(actions.meta.fetchUpdateCounts())
            );
        else dispatch(actions.meta.fetchUpdateCounts());
        // eslint-disable-next-line
    }, [isUpdateNotesModalOpen]);

// TODO: modal warning in strict mode 
// Warning: findDOMNode is deprecated in StrictMode. 
// findDOMNode was passed an instance of Transition which is inside StrictMode. 
// Instead, add a ref directly to the element you want to reference. 
// Learn more about using refs safely here: https://fb.me/react-strict-mode-find-node
    return (
        <Modal
            isOpen={isUpdateNotesModalOpen}
            centered={true}
            className="text-light"
            style={{ minWidth: '45vw' }}
            toggle={() => dispatch(actions.toggle.toggleUpdateNotesModal())}>
            <div className="w-100 border-bottom border-light text-center">
                <h2>SupportCo Update Log</h2>
            </div>
            <div
                className="m-4 overflow-auto text-light"
                style={{ maxHeight: '50vh', minHeight: '50vh' }}>
                {updates.length > 0 && updates?.map((u, x) => (
                    <div
                        key={u?.id}
                        className={classNames('border-light border-bottom', {
                            'mb-5': x < updates.length - 1,
                        })}>
                        <h3>
                            {moment.unix(u.createdDate).format('MMM DD, YYYY')}
                        </h3>
                        <div className="px-5">
                            {(u?.notes?.split('\n') || []).map((n, y) => (
                                <ReactMarkdown
                                    remarkPlugins={[gfm]}
                                    children={n}
                                    key={y + u?.id}
                                />
                            ))}
                        </div>
                    </div>
                ))}
                <div className="text-center op-8 mt-5">
                    That's everything so far
                </div>
            </div>
            <ModalFooter>
                <Button
                    color="info"
                    onClick={() =>
                        dispatch(actions.toggle.toggleUpdateNotesModal())
                    }>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default React.memo(UpdatesModal);
